<script lang="ts">
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { DistributorStore } from "@distributor/svelte/Stores/DistributorStore";

  import Flash from "@shared/services/flashv2.js";

  import type { DistributorUser } from "@shared/types/Distributor";
  import type { Notification } from "@shared/types/Notification";

  export let disableToggle: boolean = false;
  export let notification: Notification;
  export let type: string;
  export let updateNotifications: (notification: Notification) => void;

  let distributor: DistributorUser | null = $DistributorStore.currentDistributor;
  let checked = type === "phone" ? notification.phone_preference : notification.email_preference;

  const englishName = name => {
    return {
      new_order_received: "Order Notifications",
      end_of_day_report: "Daily Order Reports",
      payment_failed_for_sales_rep: "Payment Failed Notifications",
      sell_sheet_cloned_to_rep: "Product Sheet Notifications",
      multiple_payments_for_sales_rep: "Payment Made Notifications",
    }[name];
  };

  const update = notification => {
    const updatedNotification = {
      distributor_id: distributor.distributor_id,
      ...notification,
    };

    if (type === "email") {
      updatedNotification["email_preference"] = !updatedNotification.email_preference;
    } else {
      updatedNotification["phone_preference"] = !updatedNotification.phone_preference;
    }

    HttpPromise({
      url: "/api/distributor/notifications",
      method: "POST",
      data: {
        notification: updatedNotification,
      },
    })
      .then(() => {
        updateNotifications(updatedNotification);
        checked = type === "phone" ? notification.phone_preference : notification.email_preference;
      })
      .catch(error => {
        Flash.now({
          type: "error",
          message: error.errors.messages[0],
        });
      });
  };
</script>

<div class="fizz-inset-square-12 fizz-border-bottom">
  <div class="fizz-flex-row">
    <div class="fizz-stack-4 fizz-text-right">
      <label
        for="notification-{notification.name}-{type}"
        class="fizz-toggle"
        data-testid="notification-{notification.name}-{type}"
      >
        <input
          data-testid="notification-{notification.name}-{type}-input"
          disabled={disableToggle}
          id="notification-{notification.name}-{type}"
          type="checkbox"
          bind:checked
          on:click|preventDefault={() => update(notification)}
        />
        <span class="fizz-toggle-switch"></span>
      </label>
    </div>
    <div class="fizz-stack-4">
      {#if englishName(notification.name)}
        <div class="fizz-text-large fizz-text-strong">{englishName(notification.name)}</div>
      {/if}
      <div>{notification.description}</div>
    </div>
  </div>
</div>
